import { Routine } from 'redux-saga-routines';
import { searchItemsRoutine, fetchRecentRoutine } from '../routines';
import { Search } from '../../../common/models/search/Search';
import { togglePositionProfileRoutine } from '../../PositionProfile/routines';
import { showSurveyBuilderRoutine } from '../../SurveyBuilder/routines';
import { setRoleRoutine } from '../../ContactProfile/routines';
import { includes } from 'ramda';

export type GlobalSearchState = {
  recentIds: string[];
  items: Search[];
  total: number;
  loading: boolean;
  isRecentShows: boolean;
};

const initialState: GlobalSearchState = {
  recentIds: [],
  items: [],
  total: 0,
  loading: false,
  isRecentShows: true
};

export const globalSearch = (state: GlobalSearchState = initialState, { type, payload }: Routine<any>) => {
  switch (type) {
    case searchItemsRoutine.TRIGGER:
    case fetchRecentRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case searchItemsRoutine.SUCCESS:
      return {
        ...state,
        loading: false,
        total: payload.total,
        isRecentShows: false,
        items: payload.reset ? payload.items : [...state.items, ...payload.items]
      };
    case fetchRecentRoutine.SUCCESS:
      return {
        ...state,
        loading: false,
        total: payload.total,
        isRecentShows: true,
        items: payload.reset ? payload.items : [...state.items, ...payload.items]
      };
    case searchItemsRoutine.FAILURE:
      return {
        ...state,
        isRecentShows: false,
        loading: false
      };
    case fetchRecentRoutine.FAILURE:
      return {
        ...state,
        isRecentShows: true,
        loading: false
      };
    case setRoleRoutine.TRIGGER:
      return {
        ...state,
        recentIds:
          payload?.candidateId && !includes(payload.candidateId, state.recentIds)
            ? [payload.candidateId, ...state.recentIds]
            : state.recentIds
      };
    case showSurveyBuilderRoutine.TRIGGER:
    case togglePositionProfileRoutine.TRIGGER:
      return {
        ...state,
        recentIds:
          payload && !includes(payload, state.recentIds)
            ? [payload, ...state.recentIds]
            : state.recentIds
      };
    default:
      return state;
  }
};
